import { render, staticRenderFns } from "./M60SAssessment.vue?vue&type=template&id=27aa26e5&scoped=true&"
import script from "./M60SAssessment.vue?vue&type=script&lang=js&"
export * from "./M60SAssessment.vue?vue&type=script&lang=js&"
import style0 from "./M60SAssessment.vue?vue&type=style&index=0&id=27aa26e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa26e5",
  null
  
)

export default component.exports